document.addEventListener('DOMContentLoaded', function() {
  const documentMore = document.querySelectorAll('._js-document-more');

  if (documentMore.length) {
    documentMore.forEach(item => {
      item.addEventListener('click', function (event) {
        event.preventDefault();

        const parent = item.closest('._js-document-parent');
        const container = parent.querySelector('._js-document-list');

        const id = parent.getAttribute('data-id');
        const page = item.getAttribute('data-page');
        const total = item.getAttribute('data-total');

        getDocumentsList(id, page)
          .then(res => {
            item.setAttribute('data-page', Number(page) + 1);
            container.innerHTML += res.data.html;
            if (total && (Number(page) >= Number(total))) {
              item.remove();
            }
          })
          .catch(error => console.error('Ошибка загрузки документов:', error));
      });
    });
  }
});
